export const PUBLISHED = 'PUBLISHED'
export const ARCHIVED = 'ARCHIVED'
export const WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
export const FOR_APPROVAL = 'FOR_APPROVAL'
